<template>
    <div class="flex h-screen w-full overflow-y-hidden">
        <NavigationBar/>
        <NavigationModalMobile v-model="isMenuVisible" />
        <!-- Область для объектов рабочего потока -->
        <div class="flex flex-col w-full h-full items-center" v-if="!isUserStartVisible">
            <div class="flex flex-col w-full h-full items-center overflow-y-auto lg:my-32">
                <div class="flex items-center mr-auto sm:mr-0">
                    <div class="flex items-center justify-center size-10 mx-5 rounded-full cursor-pointer hover:bg-gray-200 sm:hidden"
                         v-on:click="toggleMenu"
                    >
                        <MenuDotsSvg class="size-6"/>
                    </div>
                    <div class="font-bold text-2xl my-5">Рабочая область</div>
                </div>
                <!-- Объекты Рабочего потока -->
                <WorkspaceItems @deleteWorkflow="deleteWorkflow"/>
            </div>
            <div class="h-10 w-full"></div>
        </div>
        <UserStartView v-else/>
        <WorkflowDeleteModal v-model:is-active="isWorkflowDeleteVisible" v-model:workflow-id="workflowForDelete"/>

    </div>

</template>

<script setup>
import NavigationBar from '../../components/NavigationBar.vue';
import WorkspaceItems from '@/pages/Workspace/WorkspaceItems.vue'
import MenuDotsSvg from "@/components/UI/svg/MenuDotsSvg.vue";
import NavigationModalMobile from "@/components/NavigationModalMobile.vue";
import {onMounted, ref} from 'vue'
import UserStartView from "@/pages/UserStart/UserStartView.vue";
import {Api} from "@/service/api";
import WorkflowDeleteModal from "@/pages/Flow/WorkflowDeleteModal.vue";


const isMenuVisible = ref(false)

const isUserStartVisible = ref(false)

const isWorkflowDeleteVisible = ref(false)
const workflowForDelete = ref('')

function toggleMenu() {
    isMenuVisible.value = true
}

function deleteWorkflow(workflow) {
    console.log(workflow)
    workflowForDelete.value = workflow.id
    console.log(workflowForDelete.value)
    isWorkflowDeleteVisible.value = true
}

onMounted(async () => {
    const response = await Api.getWorkflows()
    isUserStartVisible.value = response.workflows.length === 0;
})
</script>

<style scoped>

</style>
